import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";
import { Toast } from "bootstrap";


export default /*#__PURE__*/_defineComponent({
  __name: 'customAlert',
  props: {
  countDown: {
    type: Number,
    default: 750,
  },
},
  setup(__props, { expose: __expose }) {

const props = __props;

const show = ref(false);


/**
 * Use: handleShow()
 * Call this function from the parent component through "ref".
 */
const handleShow = () => {
  if (show.value) return;

  const notificationToast = document.getElementById("notification_toast");
  if (!notificationToast) return;

  // Create a Bootstrap Toast instance
  const toastInstance = new Toast(notificationToast, {
    delay: props.countDown,
  });

  // Show the toast
  toastInstance.show();
  show.value = true;

  // Add an event listener for the 'hidden.bs.toast' event
  notificationToast.addEventListener("hidden.bs.toast", () => {
    show.value = false;
    toastInstance.hide();
  });
};

__expose({
  handleShow,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "notification_toast",
    class: _normalizeClass(`toast toast-position tw-pointer-events-none ${show.value ? 'show' : ''}`),
    role: "alert",
    "aria-live": "assertive",
    "aria-atomic": "true"
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})